/* eslint-disable */

import EVENTS from '@/utils/Constants/Events';
import { rebindAll } from '@/braun/Controllers/Listing';
import { emitGtmListingImpression } from '@/utils/Controllers/GTM/Operations/ListingImpression';
import { updateProductsPositionForGTMListing } from '@/utils/Controllers/GTM/Utils';

const LISTING_WRAPPER_ID = 'js-bra-prodTilesGrid';

const updateResults = html => {
  const el = document.getElementById(LISTING_WRAPPER_ID);
  const children = document.querySelectorAll('.js-bra-prodTile');
  Array.from(children).forEach(child => el.removeChild(child));
  el.innerHTML = html;
  emitGtmListingImpression();
  rebindAll();
  el.querySelectorAll('a,button,[tabindex]').forEach(tileFocusableElement => {
    tileFocusableElement.addEventListener('focus', e => {
      document
        .querySelectorAll('.js-product-tile.hover')
        .forEach(tile => tile.classList.remove('hover'));
      const thisTile = e.target.closest('.js-product-tile');
      thisTile.classList.add('hover');
      thisTile.dispatchEvent(new Event('mouseover'));
    });
  });
};

const appendResults = ({ html, gtmEvent = null, lastPage }) => {
  const el = document.getElementById(LISTING_WRAPPER_ID);
  const listingLimitEl = document.getElementById('js-listing-page-limit');
  listingLimitEl.insertAdjacentHTML('beforebegin', html);
  el.removeChild(listingLimitEl);
  DLG.EVE.emit(EVENTS.LISTING.RESULTS.PAGEUPDATE, lastPage);
  rebindAll();
  el.querySelectorAll('a,button,[tabindex]').forEach(tileFocusableElement => {
    tileFocusableElement.addEventListener('focus', e => {
      document
        .querySelectorAll('.js-product-tile.hover')
        .forEach(tile => tile.classList.remove('hover'));
      const thisTile = e.target.closest('.js-product-tile');
      thisTile.classList.add('hover');
      thisTile.dispatchEvent(new Event('mouseover'));
    });
  });
  if (gtmEvent) {
    updateProductsPositionForGTMListing();
    emitGtmListingImpression(gtmEvent);
  }
};

export default () => {
  DLG.EVE.on(EVENTS.LISTING.RESULTS.UPDATE, updateResults);
  DLG.EVE.on(EVENTS.LISTING.RESULTS.APPEND, appendResults);
};
